// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","slowFade":"footer_slowFade__-UV51"};